<template>
    <!-- <div @mousemove="mouseMove"> -->
    <component :is="resolveLayoutVariant"
               :class="`skin-variant--${appSkinVariant}`">
        <!-- <transition :name="appRouteTransition"
                    mode="out-in"
                    appear> -->
        <div>
            <loader :visible="loading"></loader>
            <router-view></router-view>
        </div>

        <!-- </transition> -->
    </component>
    <!-- </div> -->
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed, ref } from '@vue/composition-api'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import { useLayout } from '@core/layouts/composable/useLayout'
import { useRouter } from '@core/utils'

// Layouts
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'
import useDynamicVh from '@core/utils/useDynamicVh'

import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue';
import LayoutContentCenturion from '@/layouts/variants/content/centurion/LayoutContentCenturion.vue';

import sharedServices from './services/shared-services';
import store from './store'
import { mapState } from 'vuex';
import loader from './views/loader.vue'

import Encrypted from '@/layouts/variants/encrypted/Encrypted.vue'

import { getVuetify } from '@core/utils'
import { initCenturionStateFromStore } from '@/services/centurion-state'

import platform from 'platform';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import router from './router';
// Dynamic vh

export default {
    components: {
        LayoutContentVerticalNav,
        LayoutBlank,
        loader,
        Encrypted,
        LayoutContentCenturion
    },
    computed: {

        ...mapState("loader", ["loading"])
    },
    watch: {
        $route(to, from)
        {
            window.scrollTo(0, 0);
        }
    },
    created()
    {
        initCenturionStateFromStore();
    },
    setup()
    {
        // let identitySeed = sharedServices.getIdSeed();

        // console.log('New ID Seed App View:', identitySeed);
        // identitySeed.then(id =>
        // {
        //     console.log('New ID Seed:', id.value);
        // });

        // let oldIdentitySeed = sharedServices.oldIdSeed();



        const { route } = useRouter()
        const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

        const $vuetify = getVuetify()

        const { handleBreakpointLayoutSwitch } = useLayout()
        handleBreakpointLayoutSwitch()

        // async function getBrowserId() {
        //   const fp = await FingerprintJS.load();
        //   const result = await fp.get();
        //   return result.visitorId;
        // }

        async function getPublicIp()
        {
            const res = await fetch('https://api.ipify.org?format=json');
            const data = await res.json();
            store.set('device/publicIP', data.ip);
            return data.ip;
        }

        async function getLocationName(lat, lon)
        {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`
            );
            const data = await response.json();
            if (data.display_name)
            {
                store.set('device/locationName', data.display_name);
            }
            else
            {
                store.set('device/locationName', 'Unknown');
            }
            return data.display_name;
        }

        const resolveLayoutVariant = computed(() =>
        {
            // console.log('${platform.os?.family} ${platform.os?.version}', platform.os?.family, platform.os?.version, platform.name, platform);
            // console.log('Browser ID:', result.visitorId);

            store.set('device/deviceOSAndVersion', platform.os?.family + ' ' + platform.os?.version);
            store.set('device/brand', platform.name);
            store.set('device/model', platform.version);

            // Get the browser ID using FingerprintJS
            FingerprintJS.load().then(fp =>
            {
                fp.get().then(result =>
                {
                    // console.log('Browser ID:', result.visitorId);
                    let identitySeed = result.visitorId;
                    store.set('requestKeys/identitySeed', identitySeed);
                    store.set('device/deviceId', identitySeed);
                })
            });

            // console.log('Public IP:', getPublicIp());

            getPublicIp();

            // Detecting device name and setting it in the store
            const ua = navigator.userAgent;

            if (ua.includes("Macintosh") || ua.includes("iPhone") || ua.includes("iPad"))
            {
                store.set('device/deviceName', "Apple");
            }

            if (ua.includes("Windows"))
            {
                store.set('device/deviceName', "Microsoft / PC");
            }

            if (ua.includes("Linux"))
            {
                store.set('device/deviceName', "Linux");
            }

            if (ua.includes("Android"))
            {
                store.set('device/deviceName', "Android");
            }


            navigator.geolocation.getCurrentPosition(
                pos =>
                {
                    store.set('device/locationLat', pos.coords.latitude);
                    store.set('device/locationLong', pos.coords.longitude);

                    // console.log('Location Name:', getLocationName(pos.coords.latitude, pos.coords.longitude));

                    getLocationName(pos.coords.latitude, pos.coords.longitude).then(locationName =>
                    {
                        store.set('device/locationName', locationName);
                    });
                }
            );

            let lang = localStorage.getItem('language');
            if (lang == 'en')
            {
                $vuetify.rtl = false;
            }
            else if (lang == 'ar')
            {
                $vuetify.rtl = true;
            }
            // let encrypted = localStorage.getItem('Encrypted');
            // if (encrypted == 'demo@amex')
            // {
            if (route.value.meta.layout === 'blank') return 'layout-blank'
            if (route.value.meta.layout === 'content')
            {
                return `layout-content-${appContentLayoutNav.value}-nav`
            }
            if (route.value.meta.layout === 'centurion')
            {
                return `layout-content-centurion`
            }
            // }
            // else
            // {
            //     return 'encrypted'
            // }

            return null
        })

        useDynamicVh()

        return {
            resolveLayoutVariant,
            appSkinVariant,
            appRouteTransition,
        }
    },
}
</script>
